import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { tenantAPI } from '../../services/api';

const TenantDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tenant, setTenant] = useState(null);
  const [solvability, setSolvability] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      tenantAPI.getById(id),
      tenantAPI.checkSolvability(id).catch(() => ({ data: null })),
    ]).then(([tRes, sRes]) => {
      setTenant(tRes.data);
      setSolvability(sRes.data);
      setLoading(false);
    }).catch(() => navigate('/tenants'));
  }, [id, navigate]);

  if (loading) return <div className="loading"><div className="spinner" /></div>;
  if (!tenant) return null;

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate('/tenants')}><FiArrowLeft /></button>
          <h1>{tenant.first_name} {tenant.last_name}</h1>
        </div>
      </div>

      <div className="detail-grid">
        <div>
          <div className="card">
            <div className="card-header"><h2>Informations</h2></div>
            <div className="card-body">
              <div className="detail-row"><div className="detail-label">Email</div><div className="detail-value">{tenant.email || '-'}</div></div>
              <div className="detail-row"><div className="detail-label">Téléphone</div><div className="detail-value">{tenant.phone || '-'}</div></div>
              <div className="detail-row"><div className="detail-label">Profession</div><div className="detail-value">{tenant.occupation || '-'}</div></div>
              <div className="detail-row"><div className="detail-label">Employeur</div><div className="detail-value">{tenant.employer || '-'}</div></div>
              <div className="detail-row"><div className="detail-label">Revenu mensuel</div><div className="detail-value">{tenant.monthly_income ? `${parseInt(tenant.monthly_income).toLocaleString()} XOF` : '-'}</div></div>
              <div className="detail-row"><div className="detail-label">Contact urgence</div><div className="detail-value">{tenant.emergency_contact_name || '-'} {tenant.emergency_contact_phone || ''}</div></div>
            </div>
          </div>

          <div className="card" style={{ marginTop: 16 }}>
            <div className="card-header"><h2>Contrats ({tenant.contracts?.length || 0})</h2></div>
            <div className="card-body">
              {tenant.contracts?.map(c => (
                <div key={c.id} style={{ padding: '12px 0', borderBottom: '1px solid var(--border)', cursor: 'pointer' }} onClick={() => navigate(`/leases/${c.id}`)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <strong>{c.property_title}</strong>
                    <span className={`badge badge-${c.status === 'active' ? 'success' : 'danger'}`}>{c.status}</span>
                  </div>
                  <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{parseInt(c.monthly_rent).toLocaleString()} XOF/mois | {c.property_address}</p>
                </div>
              ))}
              {(!tenant.contracts || tenant.contracts.length === 0) && <p style={{ color: 'var(--text-secondary)' }}>Aucun contrat</p>}
            </div>
          </div>
        </div>

        <div>
          {solvability && (
            <div className="card">
              <div className="card-header"><h2>Solvabilité</h2></div>
              <div className="card-body" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 48, fontWeight: 700, color: solvability.score >= 70 ? 'var(--success)' : solvability.score >= 40 ? 'var(--warning)' : 'var(--danger)' }}>
                  {solvability.score}%
                </div>
                <p style={{ color: 'var(--text-secondary)' }}>Taux de paiement: {Math.round(solvability.payment_rate)}%</p>
                <p style={{ color: 'var(--text-secondary)' }}>Total paiements: {solvability.total_payments}</p>
                <p style={{ color: 'var(--text-secondary)' }}>Impayés: {solvability.overdue}</p>
              </div>
            </div>
          )}

          <div className="card" style={{ marginTop: 16 }}>
            <div className="card-header"><h2>Paiements récents</h2></div>
            <div className="card-body">
              {tenant.recent_payments?.slice(0, 5).map(p => (
                <div key={p.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{new Date(p.due_date).toLocaleDateString('fr-FR')}</span>
                  <span style={{ fontWeight: 600 }}>{parseInt(p.amount).toLocaleString()} XOF</span>
                  <span className={`badge badge-${p.status === 'paid' ? 'success' : 'warning'}`}>{p.status}</span>
                </div>
              ))}
              {(!tenant.recent_payments || tenant.recent_payments.length === 0) && <p style={{ color: 'var(--text-secondary)' }}>Aucun paiement</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantDetailPage;
